(function () {
    'use strict';

    angular
        .module('elogbooks.user.reports')
        .controller('UserReportsExtensionRequestsPrioritiesController', UserReportsExtensionRequestsPrioritiesController);

    UserReportsExtensionRequestsPrioritiesController.$inject = ['$state', '$stateParams', 'prioritiesCollection', 'operativeResponse', 'modalConfig'];

    function UserReportsExtensionRequestsPrioritiesController($state, $stateParams, prioritiesCollection, operativeResponse, modalConfig) {
        var vm = this;

        vm.prioritiesCollection = prioritiesCollection;
        vm.priorities = prioritiesCollection.priorities;
        vm.op = operativeResponse;
        vm.totalByER = {
            accepted: 0,
            rejected: 0,
            pending: 0,
            cancelled: 0,
            total: 0
        };


        vm.prioritiesCollection.priorities.forEach(item => {
            // Sum counts from jobs
            vm.totalByER.accepted += item.jobErs.accepted;
            vm.totalByER.rejected += item.jobErs.rejected;
            vm.totalByER.pending += item.jobErs.pending;
            vm.totalByER.cancelled += item.jobErs.cancelled;
            vm.totalByER.total += item.jobErs.total;

            // Sum counts from quotes
            vm.totalByER.accepted += item.quoteErs.accepted;
            vm.totalByER.rejected += item.quoteErs.rejected;
            vm.totalByER.pending += item.quoteErs.pending;
            vm.totalByER.cancelled += item.quoteErs.cancelled;
            vm.totalByER.total += item.quoteErs.total;
        });

        vm.exportParams = {limit: 30};

        vm.entityType = $state.current.name.indexOf('quote') > -1 ? 'quoteErs' : 'jobErs';

        vm.modalConfig = modalConfig;
        }
})();
